class ContactForm extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.setupEventListeners()
  }

  setupEventListeners() {
    // Listen for HubSpot form success event from the hubspot-form element
    const hubspotForm = this.querySelector('hubspot-form')
    if (hubspotForm) {
      hubspotForm.addEventListener('hubspot-form-success', () => {
        this.showThankYouMessage()
      })
    }
  }

  showThankYouMessage() {
    const successMessage = this.querySelector('#get-in-touch-form-success')
    const form = this.querySelector('hubspot-form')
    const formHeader = this.querySelector('#form-header')

    if (successMessage && form) {
      if (formHeader) {
        formHeader.classList.add('hidden')
      }
      form.classList.add('hidden')
      successMessage.classList.remove('hidden')
      // Scroll to the thank you message
      successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}

if (!customElements.get('contact-form')) {
  customElements.define('contact-form', ContactForm)
}
